/**
 * 🔴 O NÚMERO QUE CONTA ATÉ O VALOR — o componente reutilizável dos indicadores (INDICADORES-E-CONTRATOS,
 * 06/10/2026). A contagem mora em `@/hooks/use-numero-animado`.
 *
 *  - algarismos de largura fixa (`tabular-nums`) e em UMA linha (`whitespace-nowrap`) — número que pula de
 *    largura enquanto conta faz a linha tremer;
 *  - `data-valor` carrega o valor final: o teste e o script de texto inteiro leem o alvo sem esperar a
 *    contagem acabar.
 *
 * ⚠️ Não substitui o `useCountUp` do Financeiro (1.300 ms, sempre do zero, regra daquela tela); é o irmão
 * para as telas operacionais, com a mesma curva e a mesma leitura de `prefers-reduced-motion`.
 */
import { useNumeroAnimado } from '@/hooks/use-numero-animado';
import { cn } from '@/lib/cn';

import { inteiro } from './texto-final-do-numero';

export function NumeroAnimado({
  valor,
  formatar = inteiro,
  casas = 0,
  className,
  'data-testid': testId,
}: {
  valor: number;
  /** Recebe o número já arredondado e devolve o texto (R$, horas, porcentagem…). */
  formatar?: (n: number) => string;
  /** Casas decimais durante a contagem (0 = inteiro). */
  casas?: number;
  className?: string;
  'data-testid'?: string;
}) {
  const v = useNumeroAnimado(valor);
  const fator = 10 ** casas;
  const arredondado = Math.round(v * fator) / fator;
  return (
    <span className={cn('tabular-nums whitespace-nowrap', className)} data-testid={testId} data-valor={valor}>
      {formatar(arredondado)}
    </span>
  );
}
